module.exports = __webpack_public_path__ + "1dc5b6dd4bf409a6f919be38603f76a0.woff2";